
/* injects from baggage-loader */

'use strict';

export default class CommentBoxController {

	constructor($log, Alerts, Comments) {
		'ngInject';

		this.$log = $log;
		this.Alerts = Alerts;
		this.Comments = Comments;

		this.showCommentBox = true;
		this.postingComment = false;
		this.commentBody = '';
		this.comments = [];

	}

	$onInit() {
		this.$log.log(this.comments)
	}


	/**
	 * Close the comment box and clear any text
	 */
	cancelComment() {
		this.showCommentBox = false;
		this.postingComment = false;
		this.commentBody = '';
	}


	/**
	 * Posts a comment to the project comments section
	 */
	postComment() {

		// Show progress indicator
		this.postingComment = true;

		this.$log.log(this.project)
		this.$log.log(this.parent)
		this.$log.log(this.commentBody)

		// Post the comment
		this.Comments.post({
			project: this.project,
			parent: this.parent,
			text: this.commentBody
		})
			.then(comment => {

				// Clear the comment box
				this.commentBody = '';
				this.showCommentBox = false;
				
				// Display local alert
				// this.Alerts.setLocal({
				// 	msg: 'Comment posted successfully',
				// 	type: 'success'
				// });

				// Push to comments
				if (typeof this.comments !== 'undefined') {
					this.comments.unshift(comment);
				}

				if (typeof this.onComplete === 'function') {
					this.onComplete();
				}

			});
	}

}



// WEBPACK FOOTER //
// ./src/app/components/commentBox/commentbox.controller.js